<template>
  <div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-2 pt-5 pt-md-8 bg-gradient-info">
    </base-header>

    <b-container fluid class="mt-5">
      <div class="container-fluid py-4 bg-white mb-5">
        <div v-show="loading" class="mt-3">
          <Loading />
        </div>
        <div class="row">
          <div class="col-md-3 border-right">
            <div class="d-flex flex-column align-items-center text-center p-3 py-5"><img class="rounded-circle mt-5"
                width="150px"
                src="https://st3.depositphotos.com/15648834/17930/v/600/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg">
              <span class="font-weight-bold">{{ tracer[0].nama_lengkap }}</span><span class="text-black-50">{{ tracer[0].npm }}</span><span> </span>
            </div>

          </div>

          <div class="col-md-9 border-right">
            <div class="p-3">
              <div class="card p-3">
                <div class="card-header pb-0">
                  <div class="row">
                    <h2 class="card-header d-flex justify-content-between align-items-center">
                      Data DUDI
                    </h2>
                  </div>
                </div>
                <div class="bg-white mt-5">
                  <b-tabs content-class="mt-3" fill>
                    <b-tab title="Alumni" active>
                      <table class="table align-items-center justify-content-center mb-0 mt-5">
                        <tbody>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Fakultas</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].nm_fakultas }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Prodi</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].nm_program_studi }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Angkatan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].angkatan }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Tanggal Lulus</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].tanggal_lulus }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Tanggal Wisuda</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].tanggal_wisuda }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">IPK</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].ipk }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Pembiayaan Kuliah</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].pembiayaan_kuliah }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Jenis Kelamin</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].jenis_kelamin }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Tempat Lahir</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].tmpt_lahir }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Tanggal Lahir</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].tgl_lahir }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Agama</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].agama }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Email</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].email }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">NIK</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].nik }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">NPWP</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].npwp }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">No Telp</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].tlpn_hp }}</h6> </div> </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-tab>
                    <b-tab title="Hasil Dudi">
                      <table class="table align-items-center justify-content-center mb-0 mt-5">
                        <tbody>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">No Urut Pengisisan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">Pengisian Ke- {{ tracer[0].no_pengisian }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Nama Atasan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].nm_atasan }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Jabatan Atasan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].jabatan_atasan }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Nama Tempat Kerja</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].nm_tmpt_bekerja }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Alamat Tempat Kerja</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].alamat_tmpt_kerja }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Bidang Tempat Kerja</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].bidang_tmpt_kerja }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Saran</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer[0].saran }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Harapan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm justify-content" style="width:50px; word-wrap:break-word;">{{ tracer[0].harapan }}</h6> </div> </td>
                          </tr>
                          <!-- <tr v-for="(value, propertyName, index) in tracer[0].kepuasan_terhadap_alumni">
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">kepuasan_terhadap_alumni</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm justify-content" >
                            </h6> </div> </td>
                          </tr> -->


                          <!-- <tr v-for="item in tracer.kepuasan_terhadap_alumni">{{ item }}</tr> -->

                          <tr>
                            <td>
                                <div class="d-flex px-2">
                                    <div class="my-auto">
                                        <h6 class="mb-0 text-sm">kepuasan_terhadap_alumni</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <p class="text-sm font-weight-bold mb-0">:</p>
                            </td>
                            <td>
                                <div class="my-auto">
                                  <h6 class="mb-0 text-sm justify-content" v-for="list_a in tracer[0].kepuasan_terhadap_alumni">{{ list_a.rincian }} : {{ list_a.nilai }}</h6>
                                </div>
                            </td>
                        </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">kompetensi_perusahaan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto">
                              <h6 class="mb-0 text-sm justify-content" v-for="list_p in tracer[0].kompetensi_perusahaan">{{ list_p.rincian }} : {{ list_p.nilai }}</h6>
                              </div> </td>
                          </tr>

                          </tbody>
                      </table>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
  import BaseHeader from "@/components/admin/BaseHeader";
  import SurveyService from '@/services/survey.service';
  import Loading from "@/components/Loading.vue";

  export default {
    name: "Alumni",
    components: {
      BaseHeader,
      Loading
    },
    data() {
      return {
        id_tracer_atasan : this.$route.params.id_tracer_atasan,
        tracer: [{
          kepuasan_terhadap_alumni: [{}],
          kompetensi_perusahaan: [{}]
        }],
        loading: false
      };
    },
    mounted() {
      this.getHasil();
    },
    methods: {
      getHasil() {
        this.loading = true;
        SurveyService.showHasilTracerAtasan(this.id_tracer_atasan).then(res => {
          this.tracer = res.data.data;
          if (this.tracer) {
            this.loading = false;
            return;
          }

        }).catch(error => console.error(error));
      },
    }
  };
</script>
<style scoped>
  .padding {
    padding: 20px !important;
  }

  .nav-tabs .nav-link.active {
    border-color: transparent;
    background-color: #fff !important;
    color: #121589 !important;
    border-bottom: 4px solid #121589 !important
  }

  .nav-fill .nav-item .nav-link,
  .nav-justified .nav-item .nav-link {
    width: 100%;
    color: #000
  }

  .nav-tabs .nav-link {
    border-top-left-radius: 0rem !important;
    border-top-right-radius: 0rem !important
  }

  .nav-tabs .nav-link.active {
    border-color: transparent;
    background-color: #60D0FF;
    color: #fff;
    font-weight: 600
  }

  .nav-link:hover {
    border: none
  }

  .nav-link:focus {
    outline: none
  }
</style>
